import { useState } from "react";
import Pagination from "../../components/Pagination";
import { useTranslation } from "react-i18next";
import SortedHeader from "../../components/Tables/SortedHeader";
import IconThreeDots from "../../layout/others/three-dots.svg";
import { useHistory } from "react-router";

export default function RolePermissions(props) {
  const [searchObject, setSearchObject] = useState({});
  const { t } = useTranslation();
  let history = useHistory();
  const [headers, setHeaders] = useState([
    { label: "Name", field: "Name", sorterd: true },
    { label: "" }
  ]);
  const [pageNumber, setPageNumber] = useState(1);
  const totalPages = 0;

  function onChange({ target }) {
    setSearchObject({ ...searchObject, [target.name]: target.value });
  }

  function onEditRole(roleId) {
    history.push(`/permissions/editrole/${roleId}`);
  }
  
  return (
    <>
      <div>
        <div className="d-flex row m-2">
          <div className="col-auto form-group">
            <input
              className="form-control"
              onChange={onChange}
              value={searchObject.roleId}
              placeholder={t("Role")}
              name="roleId"
              style={{ width: "240px" }}
            />
          </div>
        </div>
        <hr />
      </div>
      <div className="table-wrapper">
        <table>
          <thead>
            <SortedHeader
              searchObject={searchObject}
              setSearchObject={setSearchObject}
              headers={headers}
              setHeaders={setHeaders}
            />
          </thead>
          <tbody>
            {props.roles.map((role) => (
              <tr key={role.id}>
                <td className="text-truncate">{t(role.description)}</td>
                <td className="text-end">
                  <div className="dropdown">
                    <button
                      className="action-button"
                      type="button"
                      id="export"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src={IconThreeDots}
                        alt="threedots"
                        title={t("Options")}
                      />
                    </button>
                    <ul className="dropdown-menu dropdown-role" aria-labelledby="more">
                      <li>
                        <a
                          href="#!"
                          className="dropdown-item"
                          onClick={(event) => {
                            onEditRole(role.id);
                          }}
                          title={t("Edit")}
                          data-bs-toggle="tooltip"
                        >
                          {t("Edit")}
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="row">
        <div className="offSset">
          <Pagination
            totalPages={totalPages}
            setPageNumber={setPageNumber}
            pageNumber={pageNumber}
          />
        </div>
      </div>
    </>
  );
}
